import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useLang } from "../../contexts/LanguageContext";

export default function AdminInbox() {
  const { t } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/contact").then(({ data }) => setItems(data.items || []));
  }, []);

  return (
    <div data-testid="admin-inbox">
      <h1 className="heading-serif text-4xl text-ink mb-8">{t.admin.contact_inbox}</h1>
      {items.length === 0 ? (
        <div className="text-slate500" data-testid="inbox-empty">{t.common.no_results}</div>
      ) : (
        <div className="grid gap-3">
          {items.map((it) => (
            <div key={it.id} className="bg-white border border-slate200 p-5">
              <div className="flex items-center justify-between mb-2 text-[12px] text-slate500 uppercase tracking-widest">
                <span>{it.email}</span>
                <span>{new Date(it.created_at).toLocaleString()}</span>
              </div>
              <div className="font-semibold text-ink mb-1">{it.subject}</div>
              <div className="text-[13px] text-slate700 mb-2">{it.name}</div>
              <p className="text-[14px] text-slate600 whitespace-pre-line">{it.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
